import { render, staticRenderFns } from "./StaffPasswordEdit.vue?vue&type=template&id=c7375252&"
import script from "./StaffPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./StaffPasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports